// Ajuste de ruta: el modelo está en src/ImprovementProposal/Domain/Model/ImprovementProposal.js
import { ImprovementProposal } from "../../../Domain/Model/ImprovementProposal";

export class GetImprovementProposalList {
  constructor(
    total,
    offset,
    limit,
    records
  ) {
    this.total = total;
    this.offset = offset;
    this.limit = limit;
    this.records = records;
  }
  static createFromResponseData(data) {
    const recs = Array.isArray(data.records) ? data.records : [];
    return new GetImprovementProposalList(
      data.total ?? recs.length,
      data.offset ?? 0,
      data.limit ?? recs.length,
      recs.map(r => ImprovementProposal.createFromResponseData(r))
    );
  }
}
